import React, { Fragment } from 'react';
import { Card } from 'reactstrap';
import { Btn, LI } from '../../../AbstractElements';
import { firebase_app } from '../../../Config/Config';
import { LogOut } from 'react-feather';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth  } from 'oidc-react';
import { Icon } from '@progress/kendo-react-common';

const LogoutClass = () => {
    const history = useNavigate();
	const {signOutRedirect, userManager} = useAuth();

    const Logout = () => {
        localStorage.removeItem('profileURL');
        localStorage.removeItem('token');
		localStorage.removeItem('jwt_access_token');
        sessionStorage.removeItem('jwt_access_token')
        firebase_app.auth().signOut();

        localStorage.removeItem('auth0_profile');
        localStorage.removeItem('Name');
        localStorage.setItem('authenticated', false);
         

        userManager.signoutSilent().then(p=>{
            console.log("logout",p);
        }).catch(err=>{
            console.log(err);
        }).finally(d=>{
            userManager.signinRedirect();
        });

    };

    return (
        <Fragment>
            <LI attrLI={{ className: 'onhover-dropdown p-0', onClick: Logout }} >
                <Btn attrBtn={{ as: Card.Header, className: 'btn btn-primary-light', color: 'default' }} >
                   
                        {/* <LogOut /> */}
                        <Icon style={{ fontSize: '25px' }} className="m-r-10" name="logout" />
                        Log out
                    
                </Btn>
            </LI>
        </Fragment>
    );
};

export default LogoutClass;